import styled from 'styled-components';
import { Flex } from 'antd';

export const StatsBarStyled = styled(Flex)`
  margin-bottom: 16px;
`;

export const BackHeaderStyled = styled(Flex)`
  margin-bottom: 12px;
`;

export const CategorySectionStyled = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  & .ant-divider {
    margin: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DeleteIconStyled = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${p => p.theme?.colors?.danger ?? '#DC2626'};

  &:hover {
    opacity: 0.7;
  }
`;
